/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./getIssuedBadges.defs.js";
export { main as default } from "./getIssuedBadges.defs.js";
